import React from 'react';
import Header from '../../components/Header';
import * as H from "../Main/style"

const Brand = () => {
    return (
        <div>
            <Header />
            <H.Container>
                
            </H.Container>
        </div>
    );
};

export default Brand;